<template>
  <div>
    <div v-if="start" class="bg" @click="findAnimal($event)">
      <div v-if="currentSlide">
        <top-navbar class="top-nav" :show-back="false" :in-game="true">
          <template>
            <div slot="middle" class="data">
              <div class="total-found">{{ found }} <span class="orange">/ {{ totalLevelSlides }}</span></div>
              ANIMALS FOUND
            </div>
          </template>
        </top-navbar>
        <div v-if="currentGameEnd">
          <div class="info">
            <div class="found-text" v-if="currentFound">FOUND IT</div>
            <div class="found-text" v-if="!currentFound">TIME’S UP!</div>
            <div class="title" :class="{ green: currentSlide.post_title === 'Toad' }">
              {{ currentSlide.post_title }}
            </div>
            <button class="btn btn-primary mx-auto ng-default-btn mx-auto next-btn" @click="next()">NEXT</button>
          </div>
        </div>
        <div class="image">
          <img v-if="currentFound || currentGameEnd" ref="foundImage" :src="currentSlide.meta.found_image"/>
          <img v-if="!currentFound && !currentGameEnd" ref="seekImage" :src="currentSlide.meta.seek_image"/>
        </div>
        <div class="container-fluid fixed-bottom">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4 orange timer data text-center" :class="{ flashing }">
              {{ timeDiffText }}
            </div>
            <div class="col-4"></div>
          </div>
        </div>
      </div>
    </div>
    <game-description v-if="!start && !end" @start="startGame()" title="HIDE AND SEEK" description="RACE THE CLOCK TO SPOT THE ANIMALS HIDING IN THE IMAGES"></game-description>
  </div>
</template>

<script>
import TopNavbar from '../../components/TopNavigation'
import GameDescription from '../../components/GameDescription'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import shuffle from 'shuffle-array'

let imageLoadedInterval
let timer

export default {
  name: 'HideAndSeek',
  components: {
    GameDescription,
    TopNavbar
  },
  data () {
    return {
      start: false,
      end: false,
      currentGameEnd: false,
      gameScore: 0,
      found: 0,
      timeDiff: null,
      timeDiffText: '0:20',
      currentFound: false,
      award: false,
      totalSlides: 0,
      flashing: false,
      testSlide: 0
    }
  },
  mounted () {
    window.testHideAndSeek = this.setTestSlide
    if (this.playedHideAndSeek.length === this.hideAndSeek.length) {
      this.resetPlayedHideAndSeek()
    }
    if (this.isNextLevel) {
      this.startGame()
      this.toggleIsNextLevel()
    }
  },
  methods: {
    ...mapMutations(['setPlayedHideAndSeek', 'setFoundHideAndSeek', 'resetPlayedHideAndSeek', 'setLastGameScore', 'setNextHideAndSeekLevel', 'toggleIsNextLevel']),
    ...mapActions(['addToScore', 'cardsUnlock']),
    setTestSlide (id) {
      if (this.$route.path === '/hide-and-seek') {
        this.testSlide = id
        setTimeout(() => {
          if (this.currentSlide) {
            clearInterval(imageLoadedInterval)
            clearInterval(timer)
            this.startGame()
            this.found = 0
            this.totalSlides = 0
          }
        }, 500)
      } else {
        this.testSlide = id
        this.$router.push('/hide-and-seek')
      }
    },
    findAnimal (e) {
      if (this.$refs.seekImage && this.currentSlide && !this.currentGameEnd) {
        if (this.$refs.seekImage.width > 0) {
          const left = this.$refs.seekImage.getBoundingClientRect().left
          const scale = this.$refs.seekImage.naturalWidth / this.$refs.seekImage.width
          const x = scale * (e.pageX - left)
          const y = scale * e.pageY
          const m = {
            x1: parseInt(this.currentSlide.meta.x1),
            y1: parseInt(this.currentSlide.meta.y1),
            x2: parseInt(this.currentSlide.meta.x2),
            y2: parseInt(this.currentSlide.meta.y2),
            x3: parseInt(this.currentSlide.meta.x3),
            y3: parseInt(this.currentSlide.meta.y3),
            x4: parseInt(this.currentSlide.meta.x4),
            y4: parseInt(this.currentSlide.meta.y4)
          }
          const isInsideQuadrilateral = (x >= m.x1 && y >= m.y1 && x <= m.x2 && y >= m.y2 && x <= m.x3 && y <= m.y3 && x >= m.x4 && y <= m.y4)
          if (isInsideQuadrilateral) {
            this.currentFound = true
            this.found++
            this.setFoundHideAndSeek(this.currentSlide.ID)
            this.endGame()
          }
        }
      }
    },
    startGame () {
      this.start = true
      this.flashing = false
      clearInterval(imageLoadedInterval)
      imageLoadedInterval = setInterval(() => {
        if (this.$refs.hasOwnProperty('seekImage') && this.$refs.seekImage.complete) {
          clearInterval(imageLoadedInterval)
          this.startSlide()
        }
      }, 100)
    },
    endGame () {
      this.currentGameEnd = true
      this.flashing = false
      if (this.currentFound) {
        this.gameScore += 500
        this.addToScore(500)
      }
      clearInterval(timer)
      clearInterval(imageLoadedInterval)
    },
    startSlide () {
      let end = moment().add(20, 'seconds')
      timer = setInterval(() => {
        this.timeDiff = end.diff(moment())
        this.timeDiffText = moment(this.timeDiff).format('m:ss')
        if (moment(this.timeDiff).format('s') <= 10) {
          this.flashing = true
        }
        if (this.timeDiff <= 0) {
          this.timeDiffText = '0:00'
          this.endGame()
          clearInterval(timer)
        }
      }, 100)
    },
    next () {
      this.setPlayedHideAndSeek(this.currentSlide.ID)
      clearInterval(imageLoadedInterval)
      clearInterval(timer)
      this.start = true
      this.currentFound = false
      this.currentGameEnd = false
      this.flashing = false
      this.timeDiffText = '0:20'
      imageLoadedInterval = setInterval(() => {
        if (this.$refs.seekImage !== undefined) {
          if (this.$refs.seekImage.complete) {
            clearInterval(imageLoadedInterval)
            this.startSlide()
          }
        }
      }, 100)
      if (!this.award && this.found === 3) {
        this.cardsUnlock('hideAndSeek')
        this.award = true
      }
      this.totalSlides++
      if (!this.currentSlide) {
        this.end = true
        this.start = false
        this.setLastGameScore(this.gameScore)
        clearInterval(imageLoadedInterval)
        clearInterval(timer)
        this.setNextHideAndSeekLevel()
        this.$router.push({ name: 'GameScore' })
      }
    }
  },
  computed: {
    ...mapGetters(['hideAndSeek', 'playedHideAndSeek', 'foundHideAndSeek', 'hideAndSeekLevel', 'isNextLevel']),
    totalLevelSlides () {
      return this.hideAndSeek.filter(hideAndSeek => {
        return this.hideAndSeekLevel === hideAndSeek.meta.difficulty
      }).length
    },
    hideAndSeekSlides () {
      return this.hideAndSeek.filter(hideAndSeek => {
        return !this.playedHideAndSeek.includes(hideAndSeek.ID) && this.hideAndSeekLevel === hideAndSeek.meta.difficulty
      })
    },
    currentSlide () {
      let slide = shuffle(this.hideAndSeekSlides)
      if (this.testSlide !== 0) {
        slide = this.hideAndSeek.filter(hideAndSeek => hideAndSeek.ID === this.testSlide)
      }
      if (slide.length) {
        return slide[0]
      } else {
        return false
      }
    }
  },
  watch: {
    hideAndSeekSlides (total) {
      if (this.playedHideAndSeek.length === this.hideAndSeek.length) {
        this.resetPlayedHideAndSeek()
      }
    }
  },
  beforeDestroy () {
    clearInterval(timer)
    clearInterval(imageLoadedInterval)
  },
  destroyed () {
    clearInterval(timer)
    clearInterval(imageLoadedInterval)
  }
}
</script>

<style scoped>
  .bg {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  .data {
    font-family: 'Geograph-Bold';
    font-size: 3vw;
    color: #ffffff;
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
  }

  .timer {
    font-family: 'Geograph-Black';
    font-size: 5vw;
    color: #ffbf00;
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
  }

  .top-nav {
    position: absolute;
    z-index: 10;
  }

  .image {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 0;
    text-align: center;
  }

  .image img {
    width: 100vw;
  }

  .found-text {
    color: #228d7b;
    z-index: 9999;
    font-size: 8vw;
    text-align: center;
    font-weight: bold;
    padding-bottom: 3vh;
    -webkit-text-stroke: 0.4vw #ffd247;
    font-family: "Geograph-Bold";
  }

  .info {
    position: fixed; /* or absolute */
    top: 50%;
    left: 50%;
    color: #ffbf00;
    z-index: 9;
    text-align: center;
    font-size: 2vw;
    transform: translate(-50%, -50%);
    font-family: 'Geograph-Bold';
    width: 100%;
  }

  .info .title {
    font-size: 5vh;
    font-family: 'Geograph-Black';
    color: #ffffff;
    text-transform: uppercase;
    padding-bottom: 5vh;
  }

  .total-found {
    font-size: 7vh;
  }

  .flashing {
    animation: blinker 300ms linear infinite;
  }

  .next-btn {
    font-size: 4vh;
  }

  .green {
    color: #00bb08 !important;
  }

  @keyframes blinker {
    50% {
      color: #ffbf00;
    }
    100% {
      color: #ff0000;
    }
  }
</style>
